<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Chamadas realizadas</span>
      <span class="titulo-contexto">
        Dias com frequência registrada em cada turma ativa. Excluir uma chamada apaga os registros
        daquele dia — use quando a data tiver sido lançada por engano.
      </span>
      <span class="titulo-contexto restricao" *ngIf="!carregandoTurmas && !ehAdmin">
        Você está vendo apenas as turmas em que tem vínculo como catequista.
      </span>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="smart-toolbar">
      <div class="campo-filtro campo-filtro--wide">
        <app-autocomplete
          rotulo="Turma ativa"
          placeholder="Digite parte do nome ou o ano"
          [opcoes]="opcoesTurma"
          [selecionadoId]="turmaSelecionada"
          (selecionadoIdChange)="selecionarTurma($event)"
          [carregando]="carregandoTurmas"
          msgSemResultado="Nenhuma turma encontrada"
        ></app-autocomplete>
        <span class="dica-busca" *ngIf="carregandoTurmas">Carregando turmas…</span>
      </div>

      <div class="campo-filtro--acoes acoes-chamadas" *ngIf="turmaSelecionada">
        <button nbButton status="basic" size="medium" type="button" (click)="carregarChamadas()" title="Atualizar">
          <nb-icon pack="eva" icon="refresh-outline"></nb-icon>
          <span>Atualizar</span>
        </button>

        <button
          nbButton
          status="warning"
          size="medium"
          type="button"
          [disabled]="!chamadasSemPresenca.length || depurando || carregandoChamadas"
          [nbSpinner]="depurando"
          (click)="depurarChamadas()"
          [attr.title]="
            chamadasSemPresenca.length
              ? 'Apagar ' + chamadasSemPresenca.length + ' chamada(s) sem nenhuma presença'
              : 'Nenhuma chamada sem presença nesta turma'
          "
        >
          <nb-icon pack="eva" icon="funnel-outline"></nb-icon>
          <span>Depurar</span>
          <span class="contador-depurar" *ngIf="chamadasSemPresenca.length">{{ chamadasSemPresenca.length }}</span>
        </button>
      </div>
    </div>


    <p class="vazio erro" *ngIf="erro">{{ erro }}</p>

    <app-barra-carregando *ngIf="carregandoChamadas"></app-barra-carregando>
    <div class="smart-table-wrap" *ngIf="turmaSelecionada && !erro && chamadas.length">
      <table class="smart-table">
        <thead>
          <tr>
            <th appOrdenavel campo="data" rotuloAcessivel="Data" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Data</th>
            <th class="col-num" appOrdenavel campo="totalRegistros" rotuloAcessivel="Registros" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Registros</th>
            <th class="col-num" appOrdenavel campo="totalPresentes" rotuloAcessivel="Presenças" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Presenças</th>
            <th class="col-num" appOrdenavel campo="totalFaltas" rotuloAcessivel="Faltas" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Faltas</th>
            <th class="col-acoes col-acoes--icones">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of chamadasExibidas; trackBy: trackByData" [class.linha-sem-presenca]="semPresenca(c)">
            <td data-label="Data">
              <a
                class="link-chamada"
                [routerLink]="['/frequencia', turmaSelecionada]"
                [queryParams]="{ data: c.data }"
                [attr.aria-label]="'Abrir a chamada de ' + (paraData(c.data) | date: 'dd/MM/yyyy')"
                title="Abrir a chamada deste dia"
              >
                {{ paraData(c.data) | date: 'dd/MM/yyyy' }}
              </a>
              <span class="tag-sem-presenca" *ngIf="semPresenca(c)" title="Chamada começada e não concluída">
                sem presença
              </span>
            </td>
            <td class="col-num" data-label="Registros">{{ c.totalRegistros }}</td>
            <td class="col-num" data-label="Presenças">
              <span class="num-com-lupa">
                {{ c.totalPresentes }}
                <button
                  type="button"
                  nbButton
                  ghost
                  size="tiny"
                  status="success"
                  class="btn-quem"
                  [disabled]="!c.totalPresentes"
                  (click)="verPresentes(c)"
                  title="Ver quem esteve presente"
                  [attr.aria-label]="'Ver quem esteve presente em ' + (paraData(c.data) | date: 'dd/MM/yyyy')"
                >
                  <nb-icon pack="eva" icon="people-outline"></nb-icon>
                </button>
              </span>
            </td>
            <td class="col-num" data-label="Faltas">
              <span class="num-com-lupa">
                {{ c.totalFaltas }}
                <button
                  type="button"
                  nbButton
                  ghost
                  size="tiny"
                  status="danger"
                  class="btn-quem"
                  [disabled]="!c.totalFaltas"
                  (click)="verFaltantes(c)"
                  title="Ver quem faltou"
                  [attr.aria-label]="'Ver quem faltou em ' + (paraData(c.data) | date: 'dd/MM/yyyy')"
                >
                  <nb-icon pack="eva" icon="person-remove-outline"></nb-icon>
                </button>
              </span>
            </td>
            <td class="col-acoes col-acoes--icones" data-label="Ações">
              <div class="acao-btns acao-btns--inline" role="group">
                <button
                  type="button"
                  nbButton
                  size="small"
                  appearance="outline"
                  status="danger"
                  class="btn-acao"
                  [disabled]="excluindoData === c.data"
                  [nbSpinner]="excluindoData === c.data"
                  (click)="excluirChamada(c)"
                  title="Excluir esta chamada"
                  aria-label="Excluir esta chamada"
                >
                  <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="vazio" *ngIf="!turmaSelecionada && !carregandoTurmas && turmasAtivas.length">
      Selecione uma turma ativa para ver os dias com chamada.
    </p>
    <p class="vazio" *ngIf="!carregandoTurmas && !turmasAtivas.length">
      {{
        ehAdmin
          ? 'Nenhuma turma ativa cadastrada.'
          : 'Você não tem turmas ativas vinculadas ao seu usuário. Peça a um administrador para associar suas turmas.'
      }}
    </p>
    <app-lista-vazia
      *ngIf="turmaSelecionada && !carregandoChamadas && !erro && !chamadas.length"
      icone="calendar-outline"
      mensagem="Nenhuma chamada registrada nesta turma."
    ></app-lista-vazia>
  </nb-card-body>
</nb-card>
